/**
 * TabNavigation Component
 *
 * Full-width tabs with underline indicator.
 * Mobile: Dropdown select
 * Desktop: Horizontal tabs with underline
 */

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

interface Tab {
  id: string;
  name: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

export function TabNavigation({ tabs, activeTab, onChange }: TabNavigationProps) {
  const { darkMode } = useDarkMode();

  return (
    <div className="sticky top-16 z-40">
      {/* Horizontal tabs - Mobile & Desktop */}
      <div className={`pt-[2px] ${darkMode ? 'bg-gray-900' : 'bg-blue-50 lg:bg-white'}`}>
        <div className={`border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <nav aria-label="Tabs" className="-mb-px flex overflow-x-auto px-4 sm:px-6 lg:px-8">
            {tabs.map((tab) => {
              const isActive = tab.id === activeTab;
              return (
                <button
                  key={tab.id}
                  onClick={() => onChange(tab.id)}
                  aria-current={isActive ? 'page' : undefined}
                  className={`border-b-2 px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? darkMode
                        ? 'border-blue-500 text-blue-400'
                        : 'border-indigo-500 text-indigo-600'
                      : darkMode
                        ? 'border-transparent text-gray-400 hover:border-gray-600 hover:text-gray-300'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  }`}
                >
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}
